import { CellProps } from "@shared/primitive-components"
import { SpeedingBreakdown } from ".."
import { CompleteSpeedBands } from "../../../../api/insights"

export const SpeedingBreakdownCell = <T extends Record<string, unknown>>() =>
  function ({ value }: CellProps<CompleteSpeedBands | null, T>) {
    return <SpeedingBreakdown speedBands={value} />
  }
